import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import avatar from "./../../../assets/img/team/avatar.png";
import { Toast } from "./../../UI/toast/Toast";

import {
  faUpload,
  faUndoAlt,
  faSave,
  faPen,
  faMapPin,
  faMap,
} from "@fortawesome/free-solid-svg-icons";
import { fetchApiImageAuth2 } from "../../../helpers/api/fetch";
import { userIsFetching } from "../../../actions/authActions";

import useSWRFetchPaginationProperty from "../../../helpers/hooks/useSWRFetchPaginationProperty";
import { fetchProperties } from "../../../helpers/api/condominium";

const ProfileBanner = ({
  children,
  firstname,
  lastname,
  image,
  emphasis = false,
  loadData = () => {},
  direction,
  edit = true,
}) => {
  const dispatch = useDispatch();
  const { condominium, address } = useSelector((state) => state.condominium);
  const { token } = useSelector((state) => state.auth.user);
  const [preview, setPreview] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [prepare, setPrepare] = useState(false);
  const [loading, setLoading] = useState(false);
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { user } = useSelector((state) => state.auth);
  // eslint-disable-next-line
  const [imageCommig, setImageCommig] = useState(image);
  const inputImage = useRef();

  const [param, setParam] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });

  const {
    data: data3,
    error: error3,
    isLoading: isLoading3,
    meta: meta3,
    handler: {
      goToPage: goToPage3,
      nextPage: nextPage3,
      perPage: perPage3,
      previousPage: previousPage3,
    },
  } = useSWRFetchPaginationProperty(fetchProperties, param);

  const prepareImage = (e) => {
    if (e.target.files[0]) {
      setPreview(e.target.files[0]);
      setPreviewUrl(URL.createObjectURL(e.target.files[0]));
      setPrepare(true);
    }
  };

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
    // eslint-disable-next-line
  }, [previewUrl]);

  const property = data3.find((dato) => {
    return dato?.user?.data?.id === user?.property;
  });

  const changeImage = async () => {
    try {
      setLoading(true);
      setImageCommig(true);

      const formdata = new FormData();
      if (preview) formdata.append("picture", preview);
      formdata.append("token", token);

      await fetchApiImageAuth2("/profile/picture", formdata, "POST");

      setPrepare(false);
      if (previewUrl) URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
      setPreview(null);
      Toast.fire({
        type: "success",
        title: "Tu foto se ha actualizado!",
      });
      loadData();
      dispatch(userIsFetching({ profilePicture: true }));
      setLoading(false);
    } catch (e) {
      Toast.fire({
        type: "success",
        title: e,
      });
    } finally {
      setLoading(false);
    }
  };

  const cancelUpload = () => {
    inputImage.current.value = null;
    setImageCommig(image);
    setPreview(null);
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setPreviewUrl(null);
    setPrepare(false);
    setLoading(false);
  };

  return (
    <Card className="mb-3">
      <input
        accept="image/*"
        ref={inputImage}
        onChange={prepareImage}
        hidden
        id="changeImage"
        name="image"
        type="file"
        disabled={!edit}
      />
      <CardHeader className="d-flex position-relative min-vh-25 mb-7 justify-content-center">
        <div
          className="bg-holder rounded-soft rounded-bottom-0 bg-dark"
          style={{
            backgroundImage: `url(${
              "/assets/img/generic/" +
              Math.floor(3 + Math.random() * 10) +
              ".jpg"
            })`,
          }}
        ></div>
        <div className="avatar avatar-5xl avatar-profile">
          <img
            className="rounded-circle img-thumbnail shadow-sm"
            src={previewUrl || image}
            alt="i"
          />
          {loading && (
            <Spinner
              style={{ left: "45%", top: "45%" }}
              className="position-absolute"
              size="sm"
              color="primary"
            />
          )}
          {edit && (
            <>
              {prepare ? (
                !loading && (
                  <>
                    <Button
                      title="Realizar cambios"
                      onClick={changeImage}
                      className="rounded-capsule btn btn-falcon-primary position-absolute"
                      style={{ padding: "5px 10px", bottom: 0, right: 0 }}
                    >
                      <FontAwesomeIcon icon={faSave} />
                    </Button>
                    <Button
                      title="Deshacer cambios"
                      onClick={cancelUpload}
                      className="rounded-capsule btn btn-falcon-default position-absolute animated bounceIn"
                      style={{ padding: "5px 10px", bottom: 0, right: 45 }}
                    >
                      <FontAwesomeIcon icon={faUndoAlt} />
                    </Button>
                  </>
                )
              ) : (
                <Label
                  title={image ? "Cambia tu imagen" : "Sube una imagen"}
                  htmlFor="changeImage"
                  className="rounded-capsule btn btn-falcon-primary position-absolute animated bounceIn"
                  style={{ padding: "5px 10px", bottom: 0, right: 0 }}
                >
                  {!image ? (
                    <FontAwesomeIcon icon={faUpload} />
                  ) : (
                    <FontAwesomeIcon icon={faPen} />
                  )}
                </Label>
              )}
            </>
          )}
        </div>
      </CardHeader>

      <CardBody>
        <Row>
          <Col lg={12}>
            <h4 className="my-1">
              {`${firstname} ${lastname}`}{" "}
              {emphasis && <b className="text-primary">{emphasis}</b>}
            </h4>
            {condominium && (
              <h5 className="my-1 fs-0 font-weight-normal">
                <FontAwesomeIcon icon={faMapPin} className="mx-2" />
                {direction ??
                  `${condominium && condominium}, ${address && address}`}
              </h5>
            )}
          </Col>
          {false && (
            <Col className="pl-2 pl-lg-3">
              <a
                className="align-items-center mb-2 media"
                href="/pages/profile#!"
              >
                <img className="mr-2" src="data:image/pn" alt="" width="30" />
                <div className="media-body">
                  <h6 className="mb-0">See Followers</h6>
                </div>
              </a>
              <a
                className="align-items-center mb-2 media"
                href="/pages/profile#!"
              >
                <img className="mr-2" src="data:image/pn" alt="" width="30" />
                <div className="media-body">
                  <h6 className="mb-0">See followers (330)</h6>
                </div>
              </a>
              <a
                className="align-items-center mb-2 media"
                href="/pages/profile#!"
              >
                <img className="mr-2" src="data:image/pn" alt="" width="30" />
                <div className="media-body">
                  <h6 className="mb-0">Apple</h6>
                </div>
              </a>
              <a
                className="align-items-center mb-2 media"
                href="/pages/profile#!"
              >
                <img
                  className="mr-2"
                  src="/static/media/hp.699d6edb.png"
                  alt=""
                  width="30"
                />
                <div className="media-body">
                  <h6 className="mb-0">Hewlett Packard</h6>
                </div>
              </a>
            </Col>
          )}
        </Row>
        {children && <>{children}</>}
      </CardBody>
    </Card>
  );
};

export default ProfileBanner;
